export default function currency (v) {
	return v.toLocaleString('en-GB', {
		style: 'currency',
		currency: 'GBP',
	}).replace('.00', '');
}
